/**
 * Utility for regex patterns and validation logic.
 */

export const PATTERNS = {
    // Standard email regex
    EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,

    // Flexible phone regex: supports +, spaces, dashes, parens, 7-20 digits
    PHONE: /^\+?[0-9\s\-()]{7,20}$/,

    // Name regex: supports letters, numbers, accents, spaces, hyphens, apostrophes (2-50 chars)
    NAME: /^[a-zA-Z0-9À-ÿ\s'-]{2,50}$/,

    // Positive integers only
    NUMBER: /^[1-9][0-9]*$/
};

/**
 * Validates a value against a specific type.
 * @param {string} type - 'email', 'phone', 'name', 'number'
 * @param {string} value - The value to validate
 * @param {boolean} required - Whether the field is mandatory
 * @returns {boolean} - True if valid
 */
export const validateField = (type, value, required = false) => {
    if (!value) return !required;

    const pattern = PATTERNS[type.toUpperCase()];
    if (!pattern) return true;

    return pattern.test(value);
};
